import { render, staticRenderFns } from "./allMajorDesginDialog.vue?vue&type=template&id=1fc3318c&scoped=true"
import script from "./allMajorDesginDialog.vue?vue&type=script&lang=js"
export * from "./allMajorDesginDialog.vue?vue&type=script&lang=js"
import style0 from "./allMajorDesginDialog.vue?vue&type=style&index=0&id=1fc3318c&prod&lang=stylus&scoped=true"
import style1 from "./allMajorDesginDialog.vue?vue&type=style&index=1&id=1fc3318c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3318c",
  null
  
)

export default component.exports